type Props = {
    // IDs can be found here: https://fonts.google.com/icons
    id: string
}

export default function MaterialIcon(props: Props){
    return <span className="material-icons">{props.id}</span>
}